import { useState, useReducer } from "react";
import emailjs from "emailjs-com";
import "./contact.css";

const initialState = {
  name: "",
  email: "",
  message: "",
};

function reducer(state, action) {
  switch (action.type) {
    case "name":
      return { ...state, name: action.value };
    case "email":
      return { ...state, email: action.value };
    case "message":
      return { ...state, message: action.value };
    default:
      throw new Error();
  }
}

export default function MessageForm() {
  const [formState, dispatch] = useReducer(reducer, initialState);
  const [showFormErr, setShowFormErr] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState({
    title: "",
    paragraph: "",
  });

  const { name, email, message } = formState;

  const sendEmail = (e) => {
    e.preventDefault();
    if (name === "" || email === "" || message === "") {
      setShowFormErr(true);
      return;
    }

    const params = {
      ...formState,
    };

    setFormSubmitted({ title: "Sending message...", paragraph: "" });
    emailjs
      .send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        params,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        ({ status }) => {
          if (status === 200) {
            setFormSubmitted({
              title: "Message has been sent",
              paragraph:
                "A member of the team will be in contact with you soon.",
            });
          } else {
            setFormSubmitted({
              title:
                "Unexpected status code returned from EmailJS, try again later",
              paragraph: "Please contact Facinet either by phone or email.",
            });
          }
        },
        (err) => {
          // eslint-disable-next-line no-console
          console.log(err);
          setFormSubmitted({
            title: "Error sending message, try again later",
            paragraph: "Please contact Facinet either by phone or email.",
          });
        }
      );
    e.target.reset();
  };

  return formSubmitted.title === "" ? (
    <section id="contact">
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <form onSubmit={sendEmail}>
          <div>
            <div>
              Name:
              <input
                id="contact-form-name"
                type="text"
                value={name}
                onChange={(e) =>
                  dispatch({ type: "name", value: e.target.value })
                }
                required
              />
              Email:
              <input
                id="contact-form-email"
                type="email"
                value={email}
                onChange={(e) =>
                  dispatch({ type: "email", value: e.target.value })
                }
                required
              />
            </div>
            <div>
              Message:
              <textarea
                rows="5"
                id="contact-form-message"
                type="text"
                value={message}
                onChange={(e) =>
                  dispatch({ type: "message", value: e.target.value })
                }
                required
              />
            </div>
          </div>
          <div className="">
            {showFormErr ? (
              <p className="sm:mr-4 text-red-400">
                Please fill in all three input boxes to send a message
              </p>
            ) : null}
            <button className="btn btn-primary" type="submit">
              Send
            </button>
          </div>
        </form>
      </div>
    </section>
  ) : (
    <div className="message">
      <h3 className="">{formSubmitted.title}</h3>
      <p>{formSubmitted.paragraph}</p>
    </div>
  );
}
